<template>
  <div class="page-header">
    <van-icon
      name="arrow-left"
      class="back-icon"
      :style="{ color: color }"
      @click="handleBack"
    />
    <h1 class="page-title" :style="{ color: color }">{{ title }}</h1>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'

interface Props {
  title: string
  color: {
    type: string
    default: '#fff'
  }
}

defineProps<Props>()

const router = useRouter()

function handleBack() {
  router.back()
}
</script>

<style lang="scss" scoped>
@import '@/styles/theme.scss';

.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 32px;

  .back-icon {
    position: absolute;
    left: 0;
    font-size: 24px;
    color: $primary-color;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.7;
    }
  }

  .page-title {
    font-size: 20px;
    font-weight: 600;
    color: $primary-color;
    margin: 0;
  }
}
</style>
